import React, { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Grid, Box, CssBaseline } from "@mui/material";
import { sendPasswordResetEmail } from "firebase/auth";

import { mainLayoutStyles, showNotification } from "../../../../../constants";
import DetailsPageHeader from "../../../../../common/DetailsPageHeader";

import {
  GAUserDetailsDataFieldsSection,
  GAUserDetailsInteractionFieldsSection,
  ContributorInvitesTable,
} from "../../components/components";
import ImagePreviewModal from "../../../../../common/ImagePreviewModal";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import {
  getUserGroups,
  getUserLikes,
  getUserContributorInvites,
  updateUser,
  uploadUserImageToStorage,
} from "../../hooks/GAUsersHooks";
import { Toast } from "../../../../../common/alert";
import { useUsersContext } from "../../../../../providers/OrganizationAdmin/UsersProvider";
import { getUserContentReports } from "../../../GAContentModeration/hooks/ContentReportsHooks";
import { getSingleUser } from "../../../../../modules/OrganizationQuickTales/hooks/QuickTalesHooks";
import { ContentModerationTable } from "../../../GAContentModeration/components/components";
import { useAuth } from "../../../../../hooks";
import Scrollbars from "react-custom-scrollbars-2";
import {
  disableUserFunction,
  enableUserFunction,
  fetchUserAuthDetails,
  updateUserEmail,
  auth,
} from "../../../../../firebase";
import ConfirmationModal from "../../../../../common/ConfirmationModal";
import AddContributorInviteModal from "../../components/AddContributorInviteModal/AddContributorInviteModal";
import { getAllOrganization, getSingleOrg } from "../../../../../modules/OrgProf/hook/Organizationhook";
import { addContributorsInvites } from "../../../../../modules/Contributors/hooks/ContributorsHook";
import { updateContributor } from "../../../../../modules/Contributors/hooks/ContributorsHook";

const GAUserDetailsContainer = () => {
  const { currentUser } = useAuth();
  const {
    // handleGetAllGAUsers,
    // handleGetAllGAUsersWithAnonymous,
    setLoading,
    loading,
  } = useUsersContext();
  const location = useLocation();
  const scrollbarsRef = useRef(null);
  const { id } = useParams();

  const [userDetails, setUserDetails] = useState({});
  const [originalData, setOriginalData] = useState({});
  const [imagePreviewModal, setImagePreviewModal] = useState(false);
  const [editEnabled, setEditEnabled] = useState(false);
  const [uploadImage, setUploadImage] = useState(null);
  const [groups, setGroups] = useState(0);
  const [likes, setLikes] = useState(0);
  const [userReports, setUserReports] = useState([]);
  const [selected, setSelected] = useState([]);
  const [providerType, setProviderType] = useState(null);
  const [resetPasswordModalOpen, setResetPasswordModalOpen] = useState(false);
  const [sendingResetPasswordEmail, setSendingResetPasswordEmail] = useState(false);
  const [contributorInvites, setContributorInvites] = useState([]);
  const [addContributorModalOpen, setAddContributorModalOpen] = useState(false);
  const [allOrganizations, setAllOrganizations] = useState([]);
  const [savingContributor, setSavingContributor] = useState(false);

  console.log("user details:", userDetails);
  // console.log("iddd:", id.replace(":id", ""));

  const handleImagePreviewModalOpen = () => {
    setImagePreviewModal(true);
  };
  const handleImagePreviewModalClose = () => {
    setImagePreviewModal(false);
  };

  const canSendPasswordResetEmail =
    !!userDetails?.email &&
    // Keep consistent with other privileged actions in this view.
    // NOTE: This is UI-only gating; client Auth APIs cannot enforce admin-only permissions.
    currentUser?.role === "super";

  const handleOpenResetPasswordModal = () => {
    if (!canSendPasswordResetEmail) return;
    setResetPasswordModalOpen(true);
  };

  const handleCloseResetPasswordModal = () => {
    if (sendingResetPasswordEmail) return;
    setResetPasswordModalOpen(false);
  };

  const handleSendResetPasswordEmail = async () => {
    try {
      if (!userDetails?.email) {
        throw new Error("User does not have an email address on file.");
      }

      setSendingResetPasswordEmail(true);
      await sendPasswordResetEmail(auth, userDetails.email);
      showNotification("Password reset email sent.");
      setResetPasswordModalOpen(false);
    } catch (error) {
      Toast(
        "error",
        `Failed to send password reset email: ${error?.message || "Unknown error"}`
      );
      console.error("Error sending password reset email:", error);
    } finally {
      setSendingResetPasswordEmail(false);
    }
  };

  useEffect(() => {
    // setUserDetails({});
    fetchUserDetails();
    handleGetUserReports();
    handleGetUserGroups();
    handleGetUserLikes();
    handleGetContributorInvites();
  }, [location.state, id]);

  const fetchUserDetails = async () => {
    try {
      // Fetch the user data
      const userTempData = await getSingleUser(
        location?.state?.userDetails?.id || id.replace(":id", "")
      );

      // Try to fetch user auth details
      try {
        const userId = userTempData.id;

        // Call the Cloud Function (callable) to get auth details
        const result = await fetchUserAuthDetails({ userId });
        const userAuthDetails = result?.data;
        setProviderType(userAuthDetails?.providerData);
        console.log("Fetched user auth details:", userAuthDetails);
        console.log(
          "Fetched user auth details::::",
          userAuthDetails?.providerData
        );
      } catch (error) {
        console.error("Error fetching user auth details:", error.message);
      }

      // Combine user data and auth details
      let data = {
        ...userTempData?.data(),
        id: userTempData.id,
        // providerData: userAuthDetails?.providerData, // Assuming the response has a `data` field
      };

      // Set state with the fetched data
      setUserDetails(data);
      setOriginalData(data);
    } catch (error) {
      console.error("Error fetching user details:", error.message);
    }
  };

  // const getUserAuthDetails = async (userId) => {
  //   try {
  //     console.log("idddd:", userId);
  //     // Call the cloud function with the userId
  //     const result = await fetchUserAuthDetails({
  //       userId,
  //     });

  //     // The data returned from the cloud function
  //     const authData = result.data;

  //     console.log("User Auth Details:", authData);

  //     return authData;
  //   } catch (error) {
  //     console.error("Error fetching user auth details:", error);
  //   }
  // };

  const handleGetUserReports = async () => {
    try {
      let querySnapshot = await getUserContentReports(
        location?.state?.userDetails?.id || id.replace(":id", "")
      );
      const reportsPromises = querySnapshot.docs.map(async (item) => {
        const userTemp = await getSingleUser(item.data().reportedBy);
        return {
          ...item.data(),
          id: item.id,
          reportedByData: userTemp?.data() ? userTemp.data() : {},
        };
      });

      const contentReports = await Promise.all(reportsPromises);

      console.log("reports:", contentReports);

      setUserReports(contentReports);
    } catch (error) {
      console.log("error getting user groups:", error.message);
    }
  };

  const handleGetUserGroups = async () => {
    try {
      let response = await getUserGroups(
        location?.state?.userDetails?.id || id.replace(":id", "")
      );
      setGroups(response.length);
      console.log("groups::", response.length);
    } catch (error) {
      console.log("error getting user groups:", error.message);
    }
  };

  const handleGetUserLikes = async () => {
    try {
      let response = await getUserLikes(
        location?.state?.userDetails?.id || id.replace(":id", "")
      );
      setLikes(response);
      console.log("likes::", response);
      // setLikes(response.length);
      // console.log("likes::", response.length);
    } catch (error) {
      console.log("error getting user likes:", error.message);
    }
  };

  const handleGetContributorInvites = async () => {
    try {
      const userId = location?.state?.userDetails?.id || id.replace(":id", "");
      const invites = await getUserContributorInvites(userId);

      // Resolve organization names for sorting
      const invitesWithOrgNames = await Promise.all(
        invites.map(async (invite) => {
          try {
            if (invite.organization) {
              const orgDoc = await getSingleOrg(invite.organization);
              return {
                ...invite,
                organizationName: orgDoc?.data()?.name || "Unknown",
              };
            }
            return { ...invite, organizationName: "N/A" };
          } catch {
            return { ...invite, organizationName: "Unknown" };
          }
        })
      );

      console.log("contributor invites:", invitesWithOrgNames);
      setContributorInvites(invitesWithOrgNames);
    } catch (error) {
      console.log("error getting contributor invites:", error.message);
    }
  };

  const handleFetchAllOrganizations = async () => {
    try {
      const response = await getAllOrganization();
      if (response?.docs) {
        const orgs = response.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setAllOrganizations(orgs);
      }
    } catch (error) {
      console.log("error fetching organizations:", error.message);
    }
  };

  const handleOpenAddContributorModal = async () => {
    if (allOrganizations.length === 0) {
      await handleFetchAllOrganizations();
    }
    setAddContributorModalOpen(true);
  };

  const handleCloseAddContributorModal = () => {
    setAddContributorModalOpen(false);
  };

  const handleSaveContributorInvite = async ({ organizationId, status }) => {
    try {
      setSavingContributor(true);

      const userId = location?.state?.userDetails?.id || id.replace(":id", "");

      // Create the contributorInvites document
      const inviteData = {
        firstName: userDetails?.firstName || "",
        lastName: userDetails?.lastName || "",
        userName: userDetails?.userName || "",
        invitedUserEmail: userDetails?.email || "",
        userId: userId,
        organization: organizationId,
        status: status,
        isRequestedByUser: true,
        createdAt: new Date(),
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
      };

      await addContributorsInvites(inviteData);

      // If status is "accepted", also add org to user's organizations array
      if (status === "accepted") {
        const userResponse = await getSingleUser(userId);
        const existingOrgs = userResponse?.data()?.organizations ?? [];
        if (!existingOrgs.includes(organizationId)) {
          await updateContributor(userId, {
            organizations: [...existingOrgs, organizationId],
            updatedBy: currentUser?.id,
            updatedAt: new Date(),
          });
        }
      }

      setAddContributorModalOpen(false);
      await handleGetContributorInvites();
      showNotification("Contributor added successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error saving contributor invite:", error.message);
    } finally {
      setSavingContributor(false);
    }
  };

  const handleUpdateUser = async () => {
    try {
      setLoading(true);

      // Username validation logic
      const usernameRegex = /^[a-zA-Z0-9_-]+$/; // Only allows letters, numbers, dashes, and underscores
      if (!userDetails?.userName) {
        throw new Error(
          "Please enter a Username. Your Username can contain lower and upper case letters, numbers, dashes (-) and underscores (_)."
        );
      }
      if (!usernameRegex.test(userDetails?.userName)) {
        throw new Error(
          "Please enter a valid Username. Your Username can contain lower and upper case letters, numbers, dashes (-) and underscores (_)."
        );
      }
      let temp = {
        firstName: userDetails?.firstName ? userDetails?.firstName : "",
        lastName: userDetails?.lastName ? userDetails?.lastName : "",
        userName: userDetails?.userName ? userDetails?.userName : "",
        // email: userDetails?.email ? userDetails?.email : "",
        link: userDetails?.link ? userDetails?.link : "",
        type: (userDetails?.type ?? "user").toLowerCase(),
        // isActive: true,
        isActive: userDetails?.isActive ?? true,
        // isActive: userDetails.status === true || "active" ? true : false,
        // status: userDetails.status,
        about: userDetails?.about ? userDetails?.about : "",
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
      };
      if (userDetails?.email !== originalData?.email) {
        // Update the email in Firebase Auth via the callable Cloud Function.
        // If this fails, the error propagates to the outer catch so the user
        // is notified and the Firestore email is not updated with a bad value.
        const result = await updateUserEmail({
          uid: userDetails.id,
          newEmail: userDetails?.email,
        });
        console.log("Email update result:", result?.data);
        temp.email = userDetails?.email; // Only update the users record if the auth update succeeds
      }
      //   await changeAdminPassword({
      //     adminId: currentUser?.id,
      //     password: password,
      // })
      if (uploadImage != null) {
        let photoUrl = await uploadUserImageToStorage(
          uploadImage?.raw,
          userDetails.id
        );
        temp.photoUrl = photoUrl;
        temp.originalPhotoName = uploadImage?.raw?.name;
      }
      let responseTemp = await updateUser(userDetails.id, temp);
      if (userDetails?.isActive == true) {
        const result = await enableUserFunction({ uid: userDetails.id });
        let temp = {
          isDeleted: false,
          isActive: true,
        };
        let responseTemp = await updateUser(userDetails?.id, temp);
      } else if (userDetails?.isActive == false) {
        const result = await disableUserFunction({ uid: userDetails?.id });

        //delete user auth, but do not delete their firestore doc.
        let temp = {
          isDeleted: true,
          deletedDate: new Date(),
          isActive: false,
        };
        let responseTemp = await updateUser(userDetails?.id, temp);
      }
      // console.log("update admin response:", responseTemp);
      await fetchUserDetails();
      // await handleGetAllGAUsersWithAnonymous();
      setEditEnabled(false);
      showNotification("User updated successfully.");
      // Toast("success", "user updated successfully.");
    } catch (error) {
      showNotification(error.message);
      console.log("error updating user", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={"User Details"}
        bgColor="#fff"
        buttonText={currentUser?.role === "moderator" ? undefined : "Edit"}
        // buttonText={"Edit"}
        editEnabled={editEnabled}
        setEditEnabled={setEditEnabled}
        cancelButton={editEnabled ? true : false}
        handleSave={() => handleUpdateUser()}
        loading={loading}
        additionalButton={
          currentUser?.role === "moderator" ? undefined : "Send Reset Password"
        }
        additionalButtonUrl={handleOpenResetPasswordModal}
        disableEdit={false}
      />
      <GeneralAdminSidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"} style={subContainerStyles}>
          {/*Data card/container section*/}
          <GAUserDetailsDataFieldsSection
            userDetails={userDetails}
            setUserDetails={setUserDetails}
            handleImagePreviewModalOpen={handleImagePreviewModalOpen}
            editEnabled={editEnabled}
            uploadImage={uploadImage}
            setUploadImage={setUploadImage}
            providerType={providerType}
          />
          {/*Interactions card/container section*/}
          <GAUserDetailsInteractionFieldsSection
            userDetails={userDetails}
            setUserDetails={setUserDetails}
            editEnabled={editEnabled}
            groups={groups}
            likes={likes}
          />
          {/*Report card/container section*/}
          {/*
          <GAUserDetailsReportFieldsSection
            userDetails={userDetails}
            setUserDetails={setUserDetails}
            editEnabled={editEnabled}
          />
          */}
          {userReports?.length ? (
            <Scrollbars
              style={scrollbar}
              autoHide={true}
              ref={scrollbarsRef} // Assign the ref to Scrollbars instance
              renderThumbVertical={({ style, ...props }) => (
                <div
                  {...props}
                  style={{
                    ...style,
                    ...scrollbarprops,
                  }}
                />
              )}
            >
              <ContentModerationTable
                selected={selected}
                setSelected={setSelected}
                contentReportsData={userReports}
                userDetailsPageReports={true}
                detailsPageReports={true}
              />
            </Scrollbars>
          ) : undefined}
          {/*Contributor Invites table section*/}
          <ContributorInvitesTable
            invitesData={contributorInvites}
            onStatusChange={handleGetContributorInvites}
            onAddClick={handleOpenAddContributorModal}
          />
        </Grid>
      </Grid>
      <ImagePreviewModal
        modalOpen={imagePreviewModal}
        handleClose={handleImagePreviewModalClose}
        image={
          uploadImage != null && uploadImage.preview
            ? uploadImage.preview
            : userDetails?.photoUrl
        }
        // image={
        //   uploadImage != null && uploadImage.preview
        //     ? uploadImage.preview
        //     : images.tableDummyImage
        // }
      />

      <ConfirmationModal
        open={resetPasswordModalOpen}
        onClose={handleCloseResetPasswordModal}
        onConfirm={handleSendResetPasswordEmail}
        title="Reset password"
        message={`Send a password reset email to ${userDetails?.email || "this user"}?`}
        confirmButtonText={
          sendingResetPasswordEmail ? "Sending..." : "Send"
        }
        cancelButtonText="Cancel"
      />

      <AddContributorInviteModal
        open={addContributorModalOpen}
        onClose={handleCloseAddContributorModal}
        onSave={handleSaveContributorInvite}
        organizations={allOrganizations}
        existingOrgIds={contributorInvites.map((invite) => invite.organization)}
        loading={savingContributor}
      />
    </Box>
  );
};

export default GAUserDetailsContainer;

const subContainerStyles = {
  paddingLeft: 30,
  paddingRight: 30,
  marginTop: 50,
};

const scrollbar = { width: "100%", height: "300px", marginLeft: "auto" };
const scrollbarprops = {
  width: "4px",
  backgroundColor: "#00A7CD",
  borderRadius: "2px",
};
